export { TrendingEventsInSearch } from "./TrendingEventsInSearch";
